<template>
	<div>
		<el-form :model="freeMarket" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="freeMarket"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="市场名称" prop="marketName">
							<el-input v-model="freeMarket.marketName"></el-input>
						</el-form-item>
						<el-form-item label="所在城市" prop="cityName">
							<el-input v-model="freeMarket.cityName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="备注" prop="desc">
							<el-input v-model="freeMarket.desc"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {getFreeMarket,addFreeMarket} from '@/api/api.js'
	import tools from "@/tools"
	import Editor from 'wangeditor'
	import 'wangeditor/release/wangEditor.min.css'
	export default {
		components:{
			Editor
		},
		data(){
			return {
				freeMarket:{
					id:'',
					name:'',
					cityName:"",
					telephone:"",
					address:"",
					longitude:"",
					latitude:"",
					desc:""
				},
				rules: {
		          marketName: [
		            { required: true, message: '请输入公司名称', trigger: 'blur' }
		          ],
		          cityName: [
		            { required: true, message: '请输入所在城市', trigger: 'blur' }
		          ]
		      	},
				addLoading:false
			}

		},
		
		created:function() {
			var id = this.$route.query.id;
			
			if(id){
				getFreeMarket({id:id}).then(res=>{
					this.freeMarket = res.data.data;
				})
			};
			
		},
		methods:{
			addSubmit(){
				
				this.$refs["freeMarket"].validate((valid)=>{
					this.addLoading=true;
					if(valid){
						addFreeMarket(this.freeMarket).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					};
					this.addLoading=false;	
				});
			},
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>